import { render, staticRenderFns } from "./QuizResultKnowledgeUnitHeader.vue?vue&type=template&id=36917a8c&"
import script from "./QuizResultKnowledgeUnitHeader.vue?vue&type=script&lang=js&"
export * from "./QuizResultKnowledgeUnitHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports